$(document).ready(function(){
  $('.featured-machines-slider').slick({
    infinite: true,
  	speed: 1000,
    autoplay:true,
    autoplaySpeed: 1500,
  	slidesToShow: 5,
  	slidesToScroll: 1,
    dots: false,
  	responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
  });
});